import React from 'react';
import { useStyles } from './styles/carousel-dot.styles';

interface CarouselDotProps {
  setStep: (index: number) => void;
  step: number;
  index: number;
}

export default function CarouselDot({
  setStep,
  index,
  step,
}: CarouselDotProps) {
  const classes = useStyles();

  const activeStep = step === index;

  return (
    <div
      className={classes.dot + ' ' + (activeStep && classes.activeDot)}
      onClick={() => setStep(index)}
    />
  );
}
